var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForkandknife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "white",
    stroke: "#FE724E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "white",
    stroke: "#FE724E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0183,
    cy: 69.9031,
    r: 22.7068,
    stroke: "#ECECEC",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0183,
    cy: 69.9031,
    r: 16.3464,
    stroke: "#ECECEC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4025 51.9777C73.4501 51.0593 70.4877 49.6647 66.922 50.0502",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5083 86.4834C79.3214 85.3136 82.0732 83.5394 83.6347 80.3107",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0587 34.8242V47.6413M42.0587 47.6413V56.3145L39.3604 60.5548L41.866 98.3315C41.2877 101.993 34.7346 103.054 33.4818 98.3315L35.9874 60.5548L33 56.3145V47.6413M42.0587 47.6413H39.0231M33 47.6413V34.8242M33 47.6413H35.9874M35.9874 47.6413V34.8242M35.9874 47.6413H39.0231M39.0231 47.6413V34.8242",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4472 73.2755L93.8089 97.8496C95.3508 100.259 99.1478 103.632 102 97.8496L100.651 73.2755M100.651 73.2755H93.2307C91.5924 66.2726 90.1855 48.9712 97.6637 35.7879C98.4347 34.4387 100.092 32.5499 100.555 35.7879L100.651 73.2755ZM95.4472 54.6763C95.2216 53.1665 95.3491 48.7977 97.6637 43.4011",
    stroke: "#ECECEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5296,
    cy: 95.9221,
    r: 1,
    stroke: "#ECECEC",
    strokeWidth: 1.46929
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.0491,
    cy: 95.9221,
    r: 1,
    stroke: "#ECECEC",
    strokeWidth: 1.46929
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkandknife);
export default __webpack_public_path__ + "static/media/forkandknife.2bb8887cdf06453d04f8d2539d117987.svg";
export { ForwardRef as ReactComponent };